import { useSelector } from "react-redux";
import { useTenantPortalSetting } from "../store/portalSettings";

export default function useCompanySetting(isAuthenticated) {
  const settingId = useSelector((state) => state.app.tenantPortalSetting);

  const [setting, settingLoading] = useTenantPortalSetting(
    settingId,
    !isAuthenticated
  );

  return [setting, settingLoading];
}
